var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppleWithGlass(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_60_7884)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.463 47.7576C24.7431 52.3018 31.571 43.5649 31.407 34.7694C31.2431 26.0091 23.771 20.8091 16.463 26.6532C9.15488 20.8091 1.69456 26.0091 1.51888 34.7694C1.35492 43.5532 8.18282 52.3018 16.463 47.7576Z",
    stroke: "#010101",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0553 35.9966V38.0227",
    stroke: "#EB731A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8718 35.9966V38.0227",
    stroke: "#EB731A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.739 23.9694C17.739 23.9694 17.5282 14.3542 25.6444 12.2227C25.6444 12.2227 26.6048 16.2163 23.9814 19.6596C21.3579 23.1028 17.739 23.9694 17.739 23.9694Z",
    stroke: "#010101",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4633 26.6628C16.4633 26.6628 17.1191 18.9448 10.0219 17.3052",
    stroke: "#EB731A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6209 48.9949H42.0417L38.4111 16.4131H63.2516L59.6209 48.9949Z",
    stroke: "#010101",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5299 32.6128C49.3967 32.6128 50.0993 31.9102 50.0993 31.0435C50.0993 30.1767 49.3967 29.4741 48.5299 29.4741C47.6632 29.4741 46.9606 30.1767 46.9606 31.0435C46.9606 31.9102 47.6632 32.6128 48.5299 32.6128Z",
    fill: "#EB731A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3224 38.3633C56.1891 38.3633 56.8918 37.6607 56.8918 36.794C56.8918 35.9272 56.1891 35.2246 55.3224 35.2246C54.4557 35.2246 53.7531 35.9272 53.7531 36.794C53.7531 37.6607 54.4557 38.3633 55.3224 38.3633Z",
    fill: "#EB731A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0572 43.0572C49.9239 43.0572 50.6265 42.3546 50.6265 41.4878C50.6265 40.6211 49.9239 39.9185 49.0572 39.9185C48.1904 39.9185 47.4878 40.6211 47.4878 41.4878C47.4878 42.3546 48.1904 43.0572 49.0572 43.0572Z",
    fill: "#EB731A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.969 25.2104H61.6941",
    stroke: "#010101",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_60_7884"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleWithGlass);
export default __webpack_public_path__ + "static/media/apple-with-glass.6389350cb167c90705e1cf26289c1dd2.svg";
export { ForwardRef as ReactComponent };